import { INSPECTION_ITEM } from "../config";
import { get, post } from "./apiHelper";

export const createInspectionReport = (submissionData) => 
  post(`${INSPECTION_ITEM}/create`, submissionData);

export const updateInspectionReport = (submissionData, id) => 
  post(`${INSPECTION_ITEM}/update/${id}`, submissionData);

export const fetchInspectionItems = ({ id, tranCode, selectedInspection }) => 
  get(`${INSPECTION_ITEM}?tran_id=${id}&tran_code=${tranCode}&transaction=${selectedInspection}`);
